export default "__VITE_ASSET__CJZ45jcb__"